import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResourceColumnComponent } from 'app/resource-column/resource-column.component';
import { Component, OnInit } from '@angular/core';
import { ApiService } from "services/api.service";
import { Observable } from "rxjs/Rx";

@Component({
  selector: 'resources-editor',
  templateUrl: './resources-editor.component.html',
  styleUrls: ['./resources-editor.component.css']
})
export class ResourcesEditorComponent implements OnInit {

  scopes:string[] = [];
  resources:any = [];
  currentScope = null;
  currentSets:any[] = null;
  resourceKeys:any[] = null;
  newKey:string = null;
  saved:boolean = false;

  constructor(private api:ApiService, public activeModal:NgbActiveModal) { }

  ngOnInit() {
    this.api.getResources().subscribe(x=> {
      this.resources = x;
      var m = x.map(obj => obj.Scope);
      for(let s of m)
        if(this.scopes.indexOf(s) == -1)
          this.scopes.push(s);
      this.selectScope('global');
    });
  }

  selectScope(scope:string){
    this.currentScope = scope;
    this.resourceKeys = [];
    this.currentSets = this.resources.filter(x=>x.Scope == scope);

    //Gather all the keys
    for (let set of this.currentSets)
      for(let key in set.Resources)
        if (this.resourceKeys.find(r => r == key) === undefined)
          this.resourceKeys.push(key);
    this.sortKeys();
  }

  onKey(event: any) { // without type info
    if(event.keyCode==13 && this.newKey && this.newKey != '' && this.resourceKeys.indexOf(this.newKey) == -1) {
      this.resourceKeys.push(this.newKey);
      //add the new key with null value to all the languages
      this.currentSets.forEach(x=>x.Resources[this.newKey] = null);
      //clear the input field
      this.newKey = null;
      //display the keys, including the new key, in alphabetic order
      this.sortKeys();
    }
  }

  save(){
    let observableBatch = [];
    this.currentSets.forEach((key) => {
      observableBatch.push(this.api.saveResources(key));
    });
    Observable.forkJoin(observableBatch).subscribe(x=>{
      this.saved = true;
      setTimeout(()=>this.saved = false,2500);
    });
  }

  sortKeys(){
    this.resourceKeys = this.resourceKeys.sort((n1,n2) => {
      if (n1 > n2) return 1;
      if (n1 < n2) return -1;
      return 0;
    });
  }

  removeKey(key:string){
    this.currentSets.forEach(x=>delete x.Resources[key]);
    this.resourceKeys.splice(this.resourceKeys.indexOf(key),1);
  }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/resources-editor/resources-editor.component.ts